import type { Me } from "@dramapie/shared";

/**
 * 左下角「当前登录用户」（Wiki G-05）用到的纯函数。
 *
 * 数据只来自 `GET /api/me`：`displayName` 可能为空（OAuth 账号常见），
 * 这时退回邮箱前缀；头像用首字（原型没有真实头像，`picture` 也可能为空）。
 */

export interface AccountSummary {
  name: string;
  email: string;
  accountId: string;
  planName: string | null;
  connected: boolean;
  /** 购买页绝对地址；未连接计费端时为 null */
  purchaseUrl: string | null;
  usablePoints: number | null;
  picture: string | null;
}

export function accountName(me: Me | null | undefined): string {
  if (!me) return "";
  const display = me.displayName?.trim();
  if (display) return display;
  const local = me.email.split("@")[0]?.trim();
  return local && local.length > 0 ? local : me.email;
}

/** 首字：中文取第一个字，邮箱取第一个字母，统一大写。 */
export function initialOf(name: string): string {
  const first = [...name.trim()][0];
  return first ? first.toUpperCase() : "·";
}

export function accountInitial(me: Me | null | undefined): string {
  return initialOf(accountName(me));
}

export function summarizeAccount(me: Me | null | undefined): AccountSummary | null {
  if (!me) return null;
  return {
    name: accountName(me),
    email: me.email,
    accountId: me.accountId,
    planName: me.miya.plan?.name ?? null,
    connected: me.miya.connected,
    purchaseUrl: me.miya.purchaseUrl,
    usablePoints: me.miya.connected ? me.miya.usablePoints : null,
    picture: me.picture,
  };
}
